import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-view-job')) {
  var jobId = document.getElementById('react-component-g4-logistics-portal-view-job').getAttribute('data-job-id');
  ReactDOM.render(<JobsTable
      url = {"/api/v1/portal/jobs/view/"+jobId}
      infiniteScroll={true}
      message_if_none = 'Job not found or available for viewing.'
    />,

    document.getElementById('react-component-g4-logistics-portal-view-job'));
}
